/**
 * How an order's payment reads on screen.
 *
 * `paymentMethod` is a processor enum — COD, STRIPE, NMI, QOR. "QOR" is the
 * gateway's name: it tells a restaurant nothing about how the customer paid.
 * What is useful is the tender and the card: "Card · Visa ....1881".
 *
 * The card details are snapshotted onto the order when it is charged, so orders
 * placed before that (and legacy Stripe/NMI ones) fall back to a plain "Card".
 */
export default function paymentLabel(order) {
  if (!order) return '';
  const method = String(order.paymentMethod || '').toUpperCase();
  if (!method) return '';
  if (method === 'COD') return 'Cash';
  // A restaurant's manual delivery: the customer paid the restaurant directly.
  if (method === 'PREPAID') return 'Paid to restaurant';

  const brand = String(order.cardBrand || '').trim();
  const last4 = String(order.cardLast4 || '').replace(/\D/g, '').slice(-4);
  if (brand && last4) return `Card · ${brand} ....${last4}`;
  if (brand) return `Card · ${brand}`;
  if (last4) return `Card ....${last4}`;
  return 'Card';
}
